$('.faqList .faqItem .faqTitle').on('click', function () {
	var currentEvent = $(this);
	if (currentEvent.parent().hasClass('active')) {
		currentEvent.find('+div').slideUp(150, function () {
			currentEvent.parent().removeClass('active');
		});
	} else {
		currentEvent.find('+div').slideDown(150, function () {
			$(this).css('display', 'flex');
			var activeItem = currentEvent.parent().parent().find('.active');
			activeItem.find('.faqTitle + div').slideUp(150);
			activeItem.removeClass('active');
			currentEvent.parent().addClass('active');
		});
	}
});